<template>
    <div>
      <!-- 微信提示弹窗 -->
      <div class="wechat-alert" v-show="showWechatAlert" @click.self="closeWechatAlert">
        <div class="wechat-alert-box">
          <div class="wechat-alert-icon"></div>
          <p class="wechat-alert-text">微信内无法直接下载</p>
          <p class="wechat-alert-text">
            请点击右上角 <span style="color:#070707; font-weight: bold; font-size: 24px;"> ... </span><br>
            选择<span style="color:#070707; font-weight: bold;">「在浏览器打开」</span>即可安装
          </p>
          <a href="javascript:void(0)" class="wechat-alert-btn" @click="closeWechatAlert">我知道了</a>
        </div>
      </div>
  
      <!-- 漂浮框 -->
      <div 
        class="float-box" 
        ref="floatBox"
        @mousedown="dragStart"
        @touchstart="dragStart"
        :style="{ left: floatBoxLeft + 'px', top: floatBoxTop + 'px', right: isDragging ? 'auto' : floatBoxRight }"
      >
        <a href="https://www.goucaiwang888.com/ver/download/app.rxsz.1.0.2.apk" class="float-btn" download>
          <img src="../assets/app.png" alt="APP下载">
        </a>
        <a href="https://m.goucaiwang888.com" class="float-btn">
          <img src="../assets/h5.png" alt="H5版本">
        </a>
        <a href="https://www.goucaiwang888.com/ver/download/goucaiwang-client-setup.exe" class="float-btn">
          <img src="../assets/window.png" alt="window">
        </a>
      </div>
  
      <!-- 下载提示浮框 -->
      <!-- <div class="download-prompt" :class="{ active: showDownloadPrompt }">
        <div class="logo-area">
          <div class="logo-img"></div>
          <div>
            <span class="logo-text">瑞喜数字</span><br/>
            <span class="logo-label">专业的信息服务平台</span>
          </div>
        </div>
        <a 
          href="https://www.goucaiwang888.com/ver/download/app.rxsz.1.0.2.apk" 
          class="download-btn" 
          download
          @click="handleDownload"
        >
          立即下载
        </a>
      </div> -->
  
      <!-- 内容区域 -->
      <div class="container">
        <div class="dummy-content">
          <picture>
            <!-- 移动端图片 -->
            <source media="(max-width: 767px)" srcset="../assets/info.jpg">
            <!-- 电脑端图片 -->
            <img src="../assets/info_t.jpg" alt="内容图片" class="content-image">
          </picture>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        showWechatAlert: false,
        showDownloadPrompt: false,
        isDragging: false,
        initialX: 0,
        initialY: 0,
        floatBoxLeft: '',
        floatBoxTop: '',
        floatBoxRight: '20px'
      };
    },
    mounted() {
      this.checkWechatBrowser();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('mousemove', this.drag);
      window.addEventListener('mouseup', this.dragEnd);
      window.addEventListener('touchmove', this.drag);
      window.addEventListener('touchend', this.dragEnd);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('mousemove', this.drag);
      window.removeEventListener('mouseup', this.dragEnd);
      window.removeEventListener('touchmove', this.drag);
      window.removeEventListener('touchend', this.dragEnd);
    },
    methods: {
      checkWechatBrowser() {
        const ua = navigator.userAgent.toLowerCase();
        this.showWechatAlert = ua.indexOf('micromessenger') !== -1;
        if (this.showWechatAlert) {
          document.body.style.overflow = 'hidden';
        }
      },
      closeWechatAlert() {
        this.showWechatAlert = false;
        document.body.style.overflow = 'auto';
      },
      handleScroll() {
        const scrollPosition = window.scrollY;
        const firstScreenHeight = window.innerHeight;
        this.showDownloadPrompt = scrollPosition > firstScreenHeight * 0.2;
      },
      handleDownload(e) {
        const isAndroid = /android/i.test(navigator.userAgent);
        if (!isAndroid) {
          e.preventDefault();
          console.log('开始下载');
        }
      },
      dragStart(e) {
        this.isDragging = true;
        const floatBox = this.$refs.floatBox;
        
        if (e.type === "touchstart") {
          this.initialX = e.touches[0].clientX - floatBox.offsetLeft;
          this.initialY = e.touches[0].clientY - floatBox.offsetTop;
        } else {
          this.initialX = e.clientX - floatBox.offsetLeft;
          this.initialY = e.clientY - floatBox.offsetTop;
        }
        
        // 保存初始位置
        this.floatBoxLeft = floatBox.offsetLeft;
        this.floatBoxTop = floatBox.offsetTop;
      },
      drag(e) {
        if (this.isDragging) {
          e.preventDefault();
          
          let currentX, currentY;
          
          if (e.type === "touchmove") {
            currentX = e.touches[0].clientX - this.initialX;
            currentY = e.touches[0].clientY - this.initialY;
          } else {
            currentX = e.clientX - this.initialX;
            currentY = e.clientY - this.initialY;
          }
  
          // 限制不超出屏幕边界
          const floatBox = this.$refs.floatBox;
          const maxX = window.innerWidth - floatBox.offsetWidth;
          const maxY = window.innerHeight - floatBox.offsetHeight;
          
          currentX = Math.min(Math.max(0, currentX), maxX);
          currentY = Math.min(Math.max(0, currentY), maxY);
  
          this.floatBoxLeft = currentX;
          this.floatBoxTop = currentY;
        }
      },
      dragEnd() {
        this.isDragging = false;
      }
    }
  };
  </script>
  
  <style>
  /* 基础样式 */
  /* * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    background: #f0f2f5;
  } */
  
  /* 首屏固定下载按钮基础样式 */
  .first-screen-btn {
    position: absolute;
    top: 49%;
    left: 74%;
    transform: translateX(-50%);
    width: 41%;
    height: 75px;
    background: url(../assets/app.png) no-repeat;
    background-size: contain;
    border-radius: 30px;
    text-decoration: none;
    transition: all 0.3s ease;
    z-index: 999;
    display: block;
  }
  
  .first-screen-btn2 {
    position: absolute;
    top: 49%;
    left: 29%;
    transform: translateX(-50%);
    width: 44%;
    height: 75px;
    background: url(../assets/h5.png) no-repeat;
    background-size: contain;
    border-radius: 30px;
    text-decoration: none;
    transition: all 0.3s ease;
    z-index: 999;
    display: block;
  }
  
  /* 下载提示浮框 */
  .download-prompt {
    position: fixed;
    top: -80px;
    right: 20px;
    width: 350px;
    background: white;
    color: #333;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    padding: 20px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
    z-index: 1000;
  }
  
  .download-prompt.active {
    top: 20px;
    opacity: 1;
  }
  
  /* 左侧LOGO区域 */
  .logo-area {
    flex: 1;
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  
  .logo-img {
    width: 50px;
    height: 50px;
    margin-right: 15px;
    background: url(../assets/logo01.png) no-repeat;
    background-size: contain;
    border-radius: 10px;
  }
  
  .logo-text {
    font-size: 18px;
    font-weight: 600;
  }
  
  .logo-label {
    font-size: 12px;
    color: #666;
  }
  
  /* 下载按钮样式 */
  .download-btn {
    padding: 10px 25px;
    background: #f13f00;
    color: white;
    border-radius: 8px;
    text-decoration: none;
    font-size: 16px;
    transition: all 0.2s;
  }
  
  .download-btn:hover {
    background: #f13f00;
    transform: translateY(-1px);
  }
  
  /* 首屏内容 */
  .dummy-content {
    min-height: 150vh;
  }
  
  /* 漂浮框样式 */
  .float-box {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: rgb(255 255 255 / 8%);
    padding: 7px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 10px;
    cursor: move;
    user-select: none;
  }
  
  .float-box .float-btn {
    display: block;
    width: 120px;
    height: 40px;
    transition: all 0.3s ease;
  }
  
  .float-box .float-btn img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .float-box .float-btn:hover {
    transform: scale(1.05);
  }
  
  /* 内容容器 */
  .container {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
  }
  
  /* 图片样式 */
  .content-image {
    width: 100%;
    height: auto;
    border-radius: 0;
    box-shadow: none;
  }
  
  /* 电脑端专属样式 */
  @media (min-width: 1025px) {
    .container {
      padding: 0;
    }
    
    .dummy-content {
      width: 100vw;
      margin-left: calc(-50vw + 50%);
      margin-right: calc(-50vw + 50%);
    }
    
    .download-prompt {
      right: 40px;
      width: 380px;
      padding: 25px;
    }
  
    .logo-text {
      font-size: 20px;
    }
  
    .download-btn {
      padding: 12px 30px;
      font-size: 16px;
    }
  
    .logo-img {
      width: 60px;
      height: 60px;
    }
    
    .float-box .float-btn {
      width: 320px;
      height: 180px;
    }
  }
  
  /* 平板端适配 */
  @media (min-width: 768px) and (max-width: 1024px) {
    .download-prompt {
      right: 30px;
      width: 90%;
      padding: 20px;
    }
  
    .logo-text {
      font-size: 18px;
    }
  
    .logo-img {
      width: 55px;
      height: 55px;
    }
  
    .download-btn {
      padding: 10px 25px;
      font-size: 15px;
    }
    
    .float-box .float-btn {
      width: 280px;
      height: 160px;
    }
  }
  
  /* 移动端适配 */
  @media (max-width: 767px) {
    .download-prompt {
      width: 90%;
      right: 5%;
      padding: 12px;
    }
  
    .logo-text {
      font-size: 14px;
    }
    
    .logo-label {
      font-size: 12px;
    }
    
    .download-btn {
      padding: 8px 20px;
      font-size: 14px;
    }
    
    .float-box .float-btn {
      width: 150px;
      height: 82px;
    }
  }
  
  /* 小屏手机适配 */
  @media (max-width: 375px) {
    .float-box .float-btn {
      width: 120px;
      height: 68px;
    }
  }
  
  /* 微信提示弹窗样式 */
  .wechat-alert {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    z-index: 9999;
  }
  
  .wechat-alert-box {
    position: relative;
    width: 90%;
    max-width: 400px;
    background: #fff;
    border-radius: 15px;
    padding: 30px;
    margin: 20% auto 0;
    text-align: center;
    animation: slideIn 0.5s ease;
  }
  
  @keyframes slideIn {
    from { transform: translateY(-50px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  
  .wechat-alert-close {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #999;
    font-size: 24px;
    cursor: pointer;
  }
  
  .wechat-alert-icon {
    width: 60px;
    height: 60px;
    margin: -45px auto 20px;
    background: url('../assets/logo.png') center/70% no-repeat;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(7,193,96,0.3);
    overflow: hidden;
    background-size: 100% 100%;
    padding: 1px;
    background-clip: content-box;
    background-color: #fff;
  }
  
  .wechat-alert-text {
    color: #333;
    line-height: 1.6;
    margin: 15px 0;
    font-size: 18px;
  }
  
  .wechat-alert-btn {
    display: inline-block;
    padding: 12px 30px;
    background: #f13f00;
    color: #fff;
    border-radius: 25px;
    text-decoration: none;
    margin-top: 15px;
    font-weight: bold;
  }
  </style>


// WEBPACK FOOTER //
// src/views/appDown.vue